/* global angular, hopscotch */

var ngModule = angular.module('trends');

var $ = jQuery;
$.fn.triggerSVGEvent = function(eventName) {
    var event = document.createEvent('SVGEvents');
    event.initEvent(eventName, true, true);
    this[0].dispatchEvent(event);
    return $(this);
};

// controls the visibility of the scope button
ngModule.directive('tourButton', ['TourManager',
    function (TourManager) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element) {
                scope.$watch(TourManager.getTourAvailable, function(val) {
                    if (val) {
                        element.show();
                    }
                    else {
                        element.hide();
                    }
                }, true);

                element.on('click', function() {
                    TourManager.startTour(true);
                });
            }
        };
    }
]);

// added on each page that needs a tour, sets which tour is needed
ngModule.directive('tour', ['TourManager',
    function (TourManager) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var key = attrs.tour;
                var alternate_key = attrs.alternateTour;
                var delay = attrs.autoTourDelay;
                if (key) {
                    TourManager.setKeys(key, alternate_key);
                    if (delay) {
                        scope.$on('tourReady', function() {
                            TourManager.startTour(false);
                        });
                    }
                    else {
                        TourManager.startTour(false);
                    }
                }
            }
        };
    }
]);

ngModule.directive('tourStarter', function() {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var condition = attrs.tourStarter;
                var dispatched = false;
                scope.$watch(condition, function(val) {
                    if (val && !dispatched) {
                        scope.$emit('tourReady');
                        dispatched = true;
                    }
                }, true);
            }
        };
    }
);


// mostly necessary as the button to start the tour is out of the scope
// heirarchy controls the tour shown on the current page and its current status
ngModule.service('TourManager', ['$window', '$rootScope', '$timeout', 'Tour', 'Api',
    function ($window, $rootScope, $timeout, Tour, Api) {
        var tour = null;
        var key = '';
        // If an alternate tour is set in the html then that tour is played if
        // the first tour has (this only applies once, the button plays the
        // original tour)
        var alternate_key = '';

        // an object containing when the user saw the different tours
        var first_seen_vals = {};
        var defaultProfile = true;
        var productOptionName = 'Tour_First_Seen';

        var reset = function() {
            if (tour !== null) {
                tour.endTour();
                tour = null;
            }
        };

        var initializeTour = function() {
            // the hopscotch object is going to persist so we may as well add
            // all helpers at once

            // Homepage
            hopscotch.registerHelper('switchTab', function(val) {
                // a little dodgy, needs to run in the next digest cycle
                $timeout(function() {
                    angular.element('#content').scope().$apply('selectedTab="' + val + '"');
                });
            });

            //------
            // PPTBuilder

            hopscotch.registerHelper('showAddToPPTButton', function() {
                var button = angular.element('#add-to-pptbuilder-tour-stop');
                button.data('ppt-button-lock', true);
                button.css('opacity', 1);
            });

            hopscotch.registerHelper('hideAddToPPTButton', function() {
                var button = angular.element('#add-to-pptbuilder-tour-stop');
                button.data('ppt-button-lock', false);
                button.css('opacity', '');
            });

            hopscotch.registerHelper('openPPTBuilderMenu', function() {
                // click the button if the menu is not open
                if (angular.element('.pptbuilder-dropdown').length === 0) {
                    angular.element('#pptbuilder-button').trigger('click');
                }

                var stepNum = hopscotch.getCurrStepNum();
                $timeout(function() {
                    tour.endTour();
                    tour.start(stepNum-1);
                });
            });

            hopscotch.registerHelper('focusOnNext', function() {
                $timeout(function() {
                    jQuery('.hopscotch-next').focus();
                }, 500);
            });

            //------------
            // Trendscape

            hopscotch.registerHelper('clickCentralNode', function() {
                var path = $('#central-node');
                path.triggerSVGEvent('click');
            });

            hopscotch.registerHelper('launchTrendscapeGuide', function() {
                reset();
                window.open('/static/trends/documents/how_to_use_mintel_trendscape.pdf', '_blank');
            });

            //------------

            $rootScope.$on('$stateChangeStart', function() {
                reset();
            });

            Api.productOption.get({
                'name': productOptionName
            }).then(function(data) {
                defaultProfile = data.default_user;
                if (data.value !== '') {
                    first_seen_vals = JSON.parse(data.value);
                }
            });
        };

        this.setTourType = function(type) {
            tour = new Tour(type);
        };

        // a watch is on the tour
        this.getTourAvailable = function() {
            return tour ? true : false;
        };

        this.setKeys = function(_key, _alternate_key) {
            key = _key + '_tour';
            if (_alternate_key) {
                alternate_key = _alternate_key + '_tour';
            }
        };

        this.startTour = function(force) {
            var that = this;
            if (first_seen_vals[key] && !force && alternate_key !== '') {
                this.setTourType(alternate_key);
            }
            else {
                this.setTourType(key);
            }

            // if the tour has never been seen before play or it, or if the
            // button was pressed play it
            if ((tour && !first_seen_vals[tour.tourName] && !defaultProfile) || force)
            {
                tour.start().then(function() {
                    var d = new Date();

                    var year = d.getFullYear();
                    var month = ('0' + (d.getMonth() + 1)).slice(-2);
                    var date = ('0' + d.getDate()).slice(-2);

                    var val = '' + year + '-' + month + '-' + date;
                    that.setSeen(tour.tourSeenList, val);
                });
            }
        };

        // this needs to get all the tours
        this.setSeen = function(names, date) {
            if (!defaultProfile) {
                for (var i = 0 ; i < names.length ; i++) {
                    var name = names[i];
                    if (!first_seen_vals[name]) {
                        first_seen_vals[name] = date;
                    }
                }

                Api.productOption.customPUT({
                    'name': productOptionName,
                    'value': JSON.stringify(first_seen_vals)
                });
            }
        };

        initializeTour();
    }
]);

// a specific page tour, encapsulates the various api calls necessary to process the objects status
ngModule.factory('Tour', ['Api', '$rootScope', '$q',
    function(Api, $rootScope, $q) {
        function Tour(key) {
            this.tourJSON = null;
            this.tourName = key;
            this.tourSeenList = [this.tourName];
        }

        Tour.prototype.endTour = function() {
            hopscotch.endTour(true);
        };

        Tour.prototype.start = function(stepNum) {
            var promises = [];
            var that = this;

            if (stepNum === undefined) {
                stepNum = 0;
            }

            promises.push($q.when(this.tourJSON || Api.tour.get({'name': this.tourName}).then(function(response) {
                that.tourJSON = response.json;
                if (that.tourJSON.mintelExtraTourSeen)
                {
                    that.tourSeenList = that.tourSeenList.concat(that.tourJSON.mintelExtraTourSeen);
                }
            })));
            var promise = $q.all(promises).then(function() {
                hopscotch.startTour(that.tourJSON, stepNum);
            });

            return promise;
        };

        return Tour;
    }
])
;
